/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function LoginController(toast, loginService, userService) {
    var vm = this;

    vm.$onInit = function () {
        vm.user = {
            name: '',
            password: ''
        };

        vm.login = login;
    };

    function doLogin() {
        loginService.login(vm.user).then(function success(response) {
            var token = response.data.token;
            var refreshToken = response.data.refreshToken;
            userService.setUserFromJwtToken(token, refreshToken, true);
        }, function fail() {
        });
    }

    function login() {
        doLogin();
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.controller.js